import { buildPromoImageProps } from "../../../lib/utils";
import { getIsVertical } from "../../utils";

export const isFirstVideo = (videoData, originalVideo) => {
  return !originalVideo?._id || videoData?._id === originalVideo?._id;
};

export const resolveWrapperBaseUrl = (
  placeholderImage,
  videoData,
  originalVideo
) => {
  if (placeholderImage && isFirstVideo(videoData, originalVideo)) {
    return placeholderImage;
  }

  return videoData?.bandito?.image || videoData?.promo_image?.url || null;
};

export const getWrapperBackgroundImageProps = (
  placeholder,
  videoData,
  originalVideo,
  buildPromoImagePropsOverride
) => {
  if (placeholder?.responsive !== true) return null;

  const baseUrl = resolveWrapperBaseUrl(
    placeholder?.image,
    videoData,
    originalVideo
  );
  if (!baseUrl) return null;

  const isVertical = getIsVertical(videoData);
  return typeof buildPromoImagePropsOverride === "function"
    ? buildPromoImagePropsOverride(baseUrl, isVertical)
    : buildPromoImageProps(baseUrl, isVertical);
};
